import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-offline-device',
  templateUrl: './offline-device.component.html',
  styleUrls: ['./offline-device.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfflineDeviceComponent {}
